const masterNumbers = new Set([11, 22, 33]);
const letterValue = (letter) => ((letter.charCodeAt(0) - 65) % 9) + 1;
const cleanName = (name) => name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().replace(/[^A-Z]/g, "");

export const reduceNumber = (value, preserveMasters = true) => {
  let number = Math.abs(Number(value) || 0);
  while (number > 9 && !(preserveMasters && masterNumbers.has(number))) number = `${number}`.split("").reduce((sum, digit) => sum + Number(digit), 0);
  return number;
};

const sumLetters = (letters) => [...letters].reduce((sum, letter) => sum + letterValue(letter), 0);

const hebrewValues = {
  א:1, ב:2, ג:3, ד:4, ה:5, ו:6, ז:7, ח:8, ט:9, י:10, כ:20, ך:20, ל:30, מ:40, ם:40,
  נ:50, ן:50, ס:60, ע:70, פ:80, ף:80, צ:90, ץ:90, ק:100, ר:200, ש:300, ת:400,
};

export const calculateNumerology = ({ birthName, birthDate, hebrewName = "" }, targetDate = new Date()) => {
  const digits = birthDate.replace(/\D/g, ""); const [, month, day] = birthDate.split("-").map(Number);
  const name = cleanName(birthName); const vowels = [...name].filter((letter) => "AEIOUY".includes(letter)).join("");
  const consonants = [...name].filter((letter) => !"AEIOUY".includes(letter)).join("");
  const personalYear = reduceNumber(reduceNumber(month) + reduceNumber(day) + reduceNumber(targetDate.getFullYear()));
  const personalMonth = reduceNumber(personalYear + targetDate.getMonth() + 1);
  const personalDay = reduceNumber(personalMonth + targetDate.getDate());
  const gematria = [...hebrewName].reduce((sum, letter) => sum + (hebrewValues[letter] || 0), 0);
  return {
    lifePath: reduceNumber([...digits].reduce((sum, digit) => sum + Number(digit), 0)),
    expression: reduceNumber(sumLetters(name)), soulUrge: reduceNumber(sumLetters(vowels)),
    personality: reduceNumber(sumLetters(consonants)), birthday: reduceNumber(day),
    personalYear, personalMonth, personalDay,
    hebrewGematria: gematria || null, hebrewReduced: gematria ? reduceNumber(gematria) : null,
  };
};

export const buildKabbalahOverlay = (numerology) => {
  const sephirot = ["Keter", "Chokhmah", "Binah", "Chesed", "Gevurah", "Tiferet", "Netzach", "Hod", "Yesod", "Malkhut"];
  const indexFor = (value) => value ? (value - 1) % 10 : 9;
  return {
    focus: sephirot[indexFor(numerology.lifePath)], expression: sephirot[indexFor(numerology.expression)],
    inner: sephirot[indexFor(numerology.soulUrge)], highlighted: [...new Set([indexFor(numerology.lifePath), indexFor(numerology.expression), indexFor(numerology.soulUrge)])],
    note: "A modern symbolic overlay using numerology and the Tree of Life. It is not a substitute for traditional Jewish Kabbalah study; planetary correspondences belong primarily to Hermetic Qabalah.",
  };
};